import {
  Box,
  Button,
  DialogActions,
  IconButton,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./styles";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";

function TermsDialog(props) {
  const {
    openDialog,
    setOpenDialog,
    dialogTitle,
    termsHeading,
    termsDescription,
    showActions = false,
    forceActions = false,
    dialogPaperStyles = {},
    onAccept,
    onReject,
  } = props;

  const { t } = useTranslation("tos-modal");

  const {
    dialogPaper,
    dialogTitleBox,
    dialogTitle: dialogTitleStyle,
    closeIcon,
    dialogContent,
    contentBox,
    headingText,
    descriptionWrapper,
    descriptionText,
    dialogActions,
    actionsContainer,
    pauseText,
    acceptButton,
  } = styles;

  const handleClose = () => {
    if (!forceActions) {
      setOpenDialog(false);
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      PaperProps={{
        sx: { ...dialogPaper, ...dialogPaperStyles },
      }}
      disableEscapeKeyDown={forceActions}
      disableBackdropClick={forceActions}
    >
      <Box sx={dialogTitleBox}>
        <DialogTitle sx={dialogTitleStyle}>{dialogTitle}</DialogTitle>

        {!forceActions ? (
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon sx={closeIcon} />
          </IconButton>
        ) : null}
      </Box>

      <DialogContent sx={dialogContent}>
        <Box sx={contentBox}>
          {termsHeading && (
            <DialogContentText sx={headingText}>
              {termsHeading}
            </DialogContentText>
          )}
          <Box className="custom-scrollbar" sx={descriptionWrapper}>
            <DialogContentText sx={descriptionText}>
              {typeof termsDescription === "string" ? (
                <ReactMarkdown>{termsDescription}</ReactMarkdown>
              ) : (
                termsDescription
              )}
            </DialogContentText>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={dialogActions}>
        {showActions && (
          <Box sx={actionsContainer}>
            {onReject && (
              <Typography sx={pauseText} onClick={onReject}>
                {t("leave_community")}
              </Typography>
            )}
            {onAccept && (
              <Button variant="contained" onClick={onAccept} sx={acceptButton}>
                {t("read_and_accept")}
              </Button>
            )}
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default TermsDialog;
